import React from 'react';
import Styles from './PlayerInsightDashboardRedirect.module.scss';
import arrowLeft from '../../assets/images/icons/arrow-left.svg';

const DashboardRedirect = (props) => {
  const { onClick } = props;

  return (
    <button
      id={'dasboardRedirect'}
      className={Styles.redirectButton}
      type='button'
      onClick={() => onClick()}>
      <img src={arrowLeft} /> <span className={Styles.btnTxt}>Back to Dashboard</span>
    </button>
  );
};

export default DashboardRedirect;
